export function normalizeArray<T>(arr: (T | undefined | null)[]): T[] {
    const normalized: T[] = [];
    for (const element of arr) {
        if (element !== undefined && element !== null) {
            normalized.push(element);
        }
    }
    return normalized;
}
